// src/pages/Modules/OnDemandModule.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Typography, Grid, CardActionArea, CircularProgress } from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import { usePermissions } from '../../context/PermissionContext';
import BackButton from '../../components/BackButton';

const cardOptions = [
  {
    title: 'ON-DEMAND Help-Desk',
    icon: <SupportAgentIcon sx={{ fontSize: 50, color: 'secondary.main' }} />,
    path: '/on-demand/help-desk',
    perms: ['onDemand.helpDesk', 'onDemand.requests'],
    description: 'View and complete OnDemand Service Requests from customers'
  }
];

const OnDemandModule = () => {
  const { canAny, loading } = usePermissions();
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path);
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ position: 'relative', padding: 3 }}>
      <BackButton />
      <br /><br />
      <Box sx={{ width: '100%', p: 1 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'primary.main', mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
          <HomeRepairServiceIcon fontSize="large" color="primary" />
          ON-DEMAND MODULE
        </Typography>

        <Grid container spacing={3}>
          {cardOptions.map((option) => {
            const isAccessible = canAny(option.perms);
            if (!isAccessible) return null;

            return (
              <Grid item xs={12} sm={6} md={4} key={option.title}>
                <Card 
                  elevation={3}
                  sx={{ 
                    height: '100%', 
                    borderRadius: 3,
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: 6
                    }
                  }}
                >
                  <CardActionArea 
                    onClick={() => handleCardClick(option.path)}
                    sx={{ height: '100%', p: 2 }}
                  >
                    <CardContent sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <Box sx={{ mb: 2 }}>
                        {option.icon}
                      </Box>
                      <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
                        {option.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {option.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};

export default OnDemandModule;
